import { BoxProps } from "@mui/material";
import { ReactNode } from "react";

import AppIcon, { AppIconProps } from "../Icons/AppIcon";
import AppTooltip, { AppTooltipProps } from "../Tooltip/AppTooltip";

interface Props extends Partial<AppIconProps> {
  helperText: ReactNode;
  tooltipProps?: Partial<AppTooltipProps>;
  sx?: BoxProps["sx"];
}

/** Help icon with tooltip. */
export function HelpInfoIcon({ helperText, of = "info", tooltipProps, sx }: Props) {
  return (
    <AppTooltip title={helperText} {...tooltipProps}>
      <AppIcon sx={{ verticalAlign: "middle", ...sx }} of={of} />
    </AppTooltip>
  );
}
